'use strict';

export default angular
  .module('maestro.filters.messageText', [])

  .filter('messageText', function(utils) {
    return function(message) {
      if (message.type == 1) { // Blueline share chart message
        return utils.getMessageText(message);
      } else { // default message
        return message.text;
      }
    };
  })

  .name;
